import IncidentsReports from '@features/groups/screens/reports/IncidentsReports'
import { lazy } from 'react'
import { Route } from 'react-router-dom'
import LazyLoad from './LazyLoad'

const GroupCarePlans = lazy(
  () => import('@features/groups/screens/reports/GroupCarePlans')
)
const GroupIncidentAnalytics = lazy(
  () => import('@features/groups/screens/reports/GroupIncidentAnalytics')
)
const GroupToDosStatus = lazy(
  () => import('@features/groups/screens/reports/GroupToDosStatus')
)
const GroupBMIReports = lazy(
  () => import('@features/groups/screens/reports/GroupBMIReports')
)
const GroupDownloadCentreReports = lazy(
  () => import('@features/groups/screens/reports/DownloadCentreReports')
)
const GroupGoalsOverview = lazy(
  () => import('@features/groups/screens/reports/GroupGoalsOverview')
)

const GROUP_REPORTS_PATH = 'group-reports'
const INCIDENTS = 'incidents'
const CARE_PLANS = 'care-plans'
const TODOS = 'todos'
const BMI = 'bmi'
const DOWNLOAD_CENTRE = 'download-centre'
const GOALS_OVERVIEW = 'goals-overview'

export const GROUP_REPORTS = {
  INDEX: GROUP_REPORTS_PATH,
  INCIDENTS: `${GROUP_REPORTS_PATH}/${INCIDENTS}`,
  CARE_PLANS: `${GROUP_REPORTS_PATH}/${CARE_PLANS}`,
  TODOS: `${GROUP_REPORTS_PATH}/${TODOS}`,
  BMI: `${GROUP_REPORTS_PATH}/${BMI}`,
  DOWNLOAD_CENTRE: `${GROUP_REPORTS_PATH}/${DOWNLOAD_CENTRE}`,
  INCIDENTS_REPORT: `${GROUP_REPORTS_PATH}/${INCIDENTS}/:report`,
  GOALS_OVERVIEW: `${GROUP_REPORTS_PATH}/${GOALS_OVERVIEW}`
}

export const groupReportsRoutes = (
  <>
    <Route
      path={GROUP_REPORTS.INDEX}
      element={
        <LazyLoad>
          <GroupBMIReports />
        </LazyLoad>
      }
    />
    <Route
      path={GROUP_REPORTS.INCIDENTS}
      element={
        <LazyLoad>
          <GroupIncidentAnalytics />
        </LazyLoad>
      }
    />
    <Route
      path={GROUP_REPORTS.CARE_PLANS}
      element={
        <LazyLoad>
          <GroupCarePlans />
        </LazyLoad>
      }
    />
    <Route
      path={GROUP_REPORTS.TODOS}
      element={
        <LazyLoad>
          <GroupToDosStatus />
        </LazyLoad>
      }
    />
    <Route
      path={GROUP_REPORTS.BMI}
      element={
        <LazyLoad>
          <GroupBMIReports />
        </LazyLoad>
      }
    />
    <Route
      path={GROUP_REPORTS.DOWNLOAD_CENTRE}
      element={
        <LazyLoad>
          <GroupDownloadCentreReports />
        </LazyLoad>
      }
    />
    <Route
      path={GROUP_REPORTS.INCIDENTS_REPORT}
      element={<IncidentsReports />}
    />
    <Route
      path={GROUP_REPORTS.GOALS_OVERVIEW}
      element={
        <LazyLoad>
          <GroupGoalsOverview />
        </LazyLoad>
      }
    />
  </>
)
